import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LogClass } from "./log.classdecorater";
import { LogMethod } from "./log.methoddecorater";
import { Logger } from "./logger";

@LogClass({ source: "WebRequest" })
@Injectable()
export class LoggerInterceptor implements HttpInterceptor {
  private id = 0;
  private logger: Logger;

  @LogMethod()
  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const id = this.id++;
    const start = new Date();

    this.logger.info("Req:" + id + " - " + req.method + ": " + req.url);

    return next.handle(req).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          const end = new Date();

          this.logger.info(
            "Req:" +
              id +
              " - finished after approx: " +
              Math.round((end.getTime() - start.getTime()) / 10) / 100 +
              " seconds."
          );
          if (evt.status !== 200) {
            if (evt.status > 200 && evt.status < 300) {
              this.logger.info("Req:" + id + " - status was: " + evt.status);
            } else {
              this.logger.warn("Req:" + id + " - status was: " + evt.status);
            }
          }
        }
        // the rest is HttpSentEvent | HttpHeaderResponse | HttpResponse<T> | HttpProgressEvent | HttpUserEvent<T>
      })
    );
  }
}
